import { render, staticRenderFns } from "./publicaciones-buscador.vue?vue&type=template&id=3a536e82&scoped=true&"
import script from "./publicaciones-buscador.vue?vue&type=script&lang=ts&"
export * from "./publicaciones-buscador.vue?vue&type=script&lang=ts&"
import style0 from "./publicaciones-buscador.vue?vue&type=style&index=0&id=3a536e82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a536e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VTextField})
